module.exports = __webpack_public_path__ + "img/dmjqr2.4fc86061.jpg";